import React from 'react'
import moment from 'moment'
import Tooltip from '@material-ui/core/Tooltip'
import useTranslation from 'Hooks/useTranslation'
import { formatFleetValue } from '../fleetLiveHelpers'
import {
  PUMP_STATUS_COLORS,
  PUMP_STATUS_ERROR,
  PUMP_STATUS_RUNNING,
  PUMP_STATUS_WARNING,
  getActiveEvents,
  getEventTypeName,
  getPumpStatus,
} from './pumpCardHelpers'

const statusLabel = (status, translation) => {
  if (status === PUMP_STATUS_ERROR) return translation.fleetPumpStatusErrorLabel || 'Error'
  if (status === PUMP_STATUS_WARNING) return translation.fleetPumpStatusWarningLabel || 'Warning'
  if (status === PUMP_STATUS_RUNNING) return translation.fleetPumpStatusRunningLabel || 'Running'
  return translation.fleetPumpStatusIdleLabel || 'Idle'
}

export const PumpStatusContent = ({ unit }) => {
  const translation = useTranslation()
  const status = getPumpStatus(unit)
  const events = getActiveEvents(unit)

  return (
    <div className="fdStatusTooltip">
      <div className="fdStatusTooltipHead">
        <span className="fdDot" style={{ background: PUMP_STATUS_COLORS[status] }} />
        <b>{statusLabel(status, translation)}</b>
        {unit?.engineRpm != null ? (
          <span className="fdStatusTooltipRpm">
            {translation.fleetPumpStatusEngineRpmLabel || 'Engine RPM'}: {formatFleetValue(unit.engineRpm, 0)}
          </span>
        ) : null}
      </div>
      {events.length ? (
        <ul className="fdStatusTooltipEvents">
          {events.map((event) => {
            const type = getEventTypeName(event.type).toLowerCase()
            return (
              <li key={event.id || `${event.messageCode}-${event.timestamp}`}>
                <span
                  className="fdDot"
                  style={{ background: PUMP_STATUS_COLORS[type] || PUMP_STATUS_COLORS[PUMP_STATUS_WARNING] }}
                />
                <span className="fdStatusTooltipText">{event.text}</span>
                <span className="fdStatusTooltipTime">
                  {moment(event.timestamp).local().format('M/D/YYYY h:mm:ss A')}
                </span>
              </li>
            )
          })}
        </ul>
      ) : (
        <div className="fdStatusTooltipEmpty">
          {translation.fleetPumpStatusNoActiveEventsLabel || 'No active warnings or errors'}
        </div>
      )}
    </div>
  )
}

/** Hover card explaining the pump status light: Engine RPM and the active events behind it. */
const PumpStatusTooltip = ({ unit, disabled = false, children }) => {
  if (disabled) return children

  return (
    <Tooltip
      title={<PumpStatusContent unit={unit} />}
      placement="top-start"
      enterDelay={300}
      classes={{ tooltip: 'fdStatusTooltipPopper' }}
    >
      {children}
    </Tooltip>
  )
}

export default PumpStatusTooltip
